import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { DietAndPsychAdvice } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPrePsychScreeningData = {
    advies: DietAndPsychAdvice | null;
    toelichting: string | null;
    verslag: string | null;
};

export type BariPrePsychScreeningReadKey = keyof BariPrePsychScreeningData;
export type BariPrePsychScreeningReadLabel = 'Advies inclusie in zorgpad' | 'Toelichting' | 'Verslag consult';
export type BariPrePsychScreeningSectionTitle = 'Conclusie';

export const bariPrePsychScreeningReadSchema: TypedReadSchema<
    BariPrePsychScreeningReadKey,
    BariPrePsychScreeningReadLabel,
    BariPrePsychScreeningSectionTitle
>[] = [
    {
        items: [{ key: 'verslag', label: 'Verslag consult' }],
    },
    {
        items: [
            { key: 'advies', label: 'Advies inclusie in zorgpad' },
            { key: 'toelichting', label: 'Toelichting' },
        ],
        sectionTitle: 'Conclusie',
    },
];

const bariPrePsychScreeningFinal: TypedSchema<BariPrePsychScreeningData> = {
    advies: Koi.string().valid(...Object.values(DietAndPsychAdvice)),
    toelichting: getTextAreaStringSchema(),
    verslag: getTextAreaStringSchema(),
};

const bariPrePsychScreeningDraft: TypedSchema<BariPrePsychScreeningData> = addAllowNull(bariPrePsychScreeningFinal);

export const bariPrePsychScreeningDraftSchema = Koi.object(bariPrePsychScreeningDraft);
export const bariPrePsychScreeningFinalSchema = Koi.object(bariPrePsychScreeningFinal);
